import { ErrorResponse } from '@lsq-frontend/angular-shared/api-service';
import { FundingMethod, Guid } from '@lsq-frontend/remote-services/enterprise/common';
import {
    GetInvoiceDetailResponse,
    InvoiceBatchUploadMethod,
    RelationshipInvoice
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { Modal, Regex } from '@lsq-frontend/common-ui';
import { BehaviorSubject, Observable } from 'rxjs';
import { FileUpload, ProgressState } from 'rxjs-uploader';
import { ImagePreviewModalComponent } from '../image-preview/image-preview-modal.component';

export enum InvoiceFundingMethod {
    AddToAvailableFunds = 1,
    DisburseSubmitted = 2,
    DisburseAll = 3,
    EnterAmount = 4
}

export enum InvoiceUploadFlowStep {
    UploadOptionsSelection = 1,
    CoverSheet = 2,
    Upload = 3,
    Success = 4,
    Failure = 5
}

export enum AdditionalUploadType {
    InvoiceBatch = 1,
    InvoiceBatchImage = 2
}

export interface IInvoiceUploadMethodOption {
    method: InvoiceBatchUploadMethod;
    icon: string;
    title: string;
    description: string;
    isRecommended?: boolean;
}

export interface ICoverSheetForm {
    fundingMethod: FundingMethod;
    totalAmount?: number;
    count?: number;
    bankAccountKeyForDisbursement?: number;
    customFundingAmount?: number;
}

export class InvoiceFileUpload extends FileUpload {
    public imageKey?: Guid;
    public invoiceBatchKey?: Guid;
    public masterInvoiceBatchKey?: Guid;
    public imageId?: string;
    public linkedFileUploads: InvoiceFileUpload[] = [];
    public linkedFileUploadsCount = 0;
    public isMobileUpload?: boolean;
    public pages?: number;
    public url?: string;
    public previewUrl?: string;
    public isUploadStatusComplete?: boolean;

    public get hasFailed(): boolean {
        if (!!this.response) {
            if (this.response && (this.response as any).status) {
                return !(this.response as any).status
                    .toString()
                    .match(Regex.HttpSuccessOrRedirectCode);
            }
            if (this.response instanceof ErrorResponse) {
                return !this.response.code.toString().match(Regex.HttpSuccessOrRedirectCode);
            }
        }
        if (!!this.responseCode) {
            return !this.responseCode.toString().match(Regex.HttpSuccessOrRedirectCode);
        }
        return this.progress.state === ProgressState.Failed || this.rejected;
    }

    public reset(): void {
        super.reset();
        this.url = null;
        this.previewUrl = null;
    }
}

export interface IAdditionalUploadsModalConfig {
    parentFileUpload?: InvoiceFileUpload;
    fileUploadsSubject?: BehaviorSubject<InvoiceFileUpload[]>;
    fileInputElement?: HTMLInputElement;
    invoiceBatchKey?: Guid;
    masterInvoiceBatchKey?: Guid;
    onSuccess?: () => any;
}

export interface IBatchUploaderData<StreamType = InvoiceFileUpload[]> {
    fileUploadsStream: Observable<StreamType>;
    inputElement: HTMLInputElement;
    invoiceBatchKey?: Guid;
    invoiceBatchKeys?: Set<Guid>;
}

export class InvoiceHistoricalImagePreviewModal extends Modal {
    public id = 'image-preview-modal';
    public component = ImagePreviewModalComponent;
    public width = 'auto';

    constructor(invoice: RelationshipInvoice | GetInvoiceDetailResponse) {
        super();
        this.title = `Invoice ${invoice.invoiceNumber}`;
        this._data = {
            title: `Invoice # ${invoice.invoiceNumber}`,
            invoiceKey: invoice.invoiceKey,
            filename: `invoice_${invoice.invoiceNumber}`
        };
    }
}
